import axios from "axios";
const API = process.env.REACT_APP_API_URL || "/api";

function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function post_paipan(data) {
  try {
    const anonymousId = localStorage.getItem("anonymous_id");
    const payload = {
      ...data,
      anonymous_id: anonymousId || undefined,
    };
    const res = await axios.post(API + "/paipan", payload, {
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    });
    console.log(res);
    if (res.status >= 200 && res.status < 300) {
      return res.data;
    } else {
      console.log(res);
    }
  } catch (err) {
    console.log(err);
  }
  return;
}

async function post_login(data) {
  try {
    const res = await axios.post(API + "/login", data, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.status >= 200 && res.status < 300) {
      return res.data;
    }
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response.data;
    }
    console.log(err);
  }
  return;
}

async function post_register(data) {
  try {
    const anonymousId = localStorage.getItem("anonymous_id");
    const payload = {
      ...data,
      anonymous_id: anonymousId || undefined,
    };
    const res = await axios.post(API + "/register", payload, {
      headers: { "Content-Type": "application/json" },
    });
    if (res.status >= 200 && res.status < 300) {
      return res.data;
    }
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response.data;
    }
    console.log(err);
  }
  return;
}

// ============ 通讯录相关 API ============

async function get_people(category) {
  try {
    let url = category ? API + "/people?category=" + encodeURIComponent(category) : API + "/people";
    const res = await axios.get(url, {
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    });
    if (res.status >= 200 && res.status < 300) {
      return res.data;
    }
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response.data;
    }
    console.log(err);
  }
  return;
}

async function add_people(data) {
  try {
    const payload = {
      ...data,
      use_zaozi: data.use_zaozi ? 1 : 0,
      use_true_solar: data.use_true_solar ? 1 : 0,
    };
    const res = await axios.post(API + "/people", payload, {
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    });
    if (res.status === 201) {
      return res.data;
    }
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response.data;
    }
    console.log(err);
  }
  return;
}

async function update_people(id, data) {
  try {
    const payload = {
      ...data,
      use_zaozi: data.use_zaozi ? 1 : 0,
      use_true_solar: data.use_true_solar ? 1 : 0,
    };
    const res = await axios.put(API + "/people/" + id, payload, {
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    });
    if (res.status >= 200 && res.status < 300) {
      return res.data;
    }
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response.data;
    }
    console.log(err);
  }
  return;
}

async function delete_people(id) {
  try {
    const res = await axios.delete(API + "/people/" + id, {
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    });
    if (res.status >= 200 && res.status < 300) {
      return res.data;
    }
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response.data;
    }
    console.log(err);
  }
  return;
}

async function migrate_anonymous(anonymous_id, record_ids = []) {
  try {
    const res = await axios.post(
      API + "/migrate-anonymous",
      { anonymous_id, record_ids },
      { headers: { "Content-Type": "application/json", ...getAuthHeaders() } }
    );
    if (res.status >= 200 && res.status < 300) {
      return res.data;
    }
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response.data;
    }
    console.log(err);
  }
  return;
}

async function post_redeem(code) {
  try {
    const res = await axios.post(
      API + "/redeem",
      { code },
      { headers: { "Content-Type": "application/json", ...getAuthHeaders() } }
    );
    if (res.status >= 200 && res.status < 300) {
      return res.data;
    }
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response.data;
    }
    console.log(err);
  }
  return;
}

async function get_me() {
  try {
    const res = await axios.get(API + "/me", {
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    });
    if (res.status >= 200 && res.status < 300) {
      return res.data;
    }
  } catch (err) {
    console.log(err);
  }
  return;
}

export {
  post_paipan,
  post_login,
  post_register,
  get_people,
  add_people,
  update_people,
  delete_people,
  migrate_anonymous,
  post_redeem,
  get_me,
};
